export default "__VITE_ASSET__DsCrFtBl__"